import { useEffect, useState } from "react";
import { hasProductClientId, ynetProductClientId, getUsernameFromEmail, getUserLabel } from "../../../../../global/paywall/paywallUtils"
import { UserWithEmail } from "../../../../../global/paywall/paywallInterfaces";


interface PremiumPaywallMobileSigninFinishProps {
  setIsRedirecting?: (isRedirect: boolean) => void;
  user?: UserWithEmail
}

declare const window: Window & {
  articleId: string;
}


export const PremiumPaywallMobileSigninFinish = (props: PremiumPaywallMobileSigninFinishProps) => {
  const [subscribed, setSubscribed] = useState(true);
  const { setIsRedirecting, user } = props;
  const isInsideArticle = typeof window !== "undefined" && window.articleId && window.articleId.length > 0;
 

  
  const handleRedirect = () => {
    if (isInsideArticle) {
      location.reload();
    } else {
      setIsRedirecting(true);
    }
  }

useEffect(() => {
  const timer = setTimeout(() => {
    handleRedirect();
  }, 3000);

  return () => {
    clearTimeout(timer);
  };
}, []);
 

  let displayName = user && user.displayName && user.displayName.trim();
  displayName = getUserLabel(displayName)

  return (
    <div className="premium-paywall-mobile-signin-finish">
      <div className="title">{`שלום ${displayName}`}</div>
      <div className="subtitle">
        שמחים שחזרת, מיד ייפתח העמוד המבוקש
      </div>

      <div className="resend-code-text">
        העמוד לא התרענן?<button onClick={handleRedirect}>לחצו כאן</button>
      </div>
    </div>
  )
}
